import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-family: ${theme.v2.font.family.primary};
    color: ${theme.v2.colors.brand.primaryExtraDark};
    max-width: 685px;
    height: 100%;
`};
`;

export const TitleWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: 18px;

  @media (max-width: ${theme.v2.breakpoints.sm}) {
      display: flex;
      flex-direction: column;
      gap: 8px;
      align-items: center;
    }
  `};
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: 28px;
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 42px;
    margin: 0 0 6px 0;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.md};
      line-height: 36px;
      margin-bottom: 24px;
    }
  `};
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
  `};

  p {
    margin: 0;
  }
`;

export const BulletPointsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  margin: 32px 0 32px 0;
`;

export const BulletPointsTitle = styled.h2`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.bold};
    color: ${theme.v2.colors.brand.primaryMedium};
    margin: 0;
  `};
`;

export const BulletPoint = styled.p`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: 10px;
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
    text-align: start;
  `};
`;

export const CheckboxLabel = styled.label`
    align-items: center;
    cursor: pointer;
    display: inline-flex;
`;
